import React from "react";

import EventList from "./EventList";
import AdminSearchWidget from "../db-list/AdminSearchWidget";
import ListWrapper from "../../../common/management/ListWrapper";
import ListContentWrapper from "../../../common/management/ListContentWrapper";
import { SonicTermData } from "../../../common/classes/SonicTerm";

import { useAppSelector } from "../../../redux/hooks";
import { getAuthToken } from "../../../redux/reducers/auth";

import { genDisplayCount } from "../../../utils/GeneralUtils";
import { TermType, useGetTerm } from "../../../utils/useTerm";
import { useGetEventAdmin } from "../../../utils/useEvent";

type Props = {
  handleSearch?: (search: Array<string>) => void;
  handleStatus?: (status: string) => void;
  handleCategory?: (category: string) => void;
  currentPage: number;
  perView: number;
  isSelect: boolean;
  search?: Array<string>;
  status?: string | string[];
  category?: string;
};

const EventListContainer: React.FC<Props> = ({
  handleSearch,
  handleStatus,
  handleCategory,
  currentPage,
  perView,
  isSelect,
  search,
  status,
  category,
}) => {
  const auth_token = useAppSelector(getAuthToken);

  const {
    termData: { entries: eventTermData },
  } = useGetTerm(TermType.EventTypes, undefined, -1);

  const {
    items: { events, owners, total_entries: entries, total_pages: totalPage },
    isLoading,
  } = useGetEventAdmin({
    auth_token: auth_token,
    is_jikei_request: !isSelect,
    page: currentPage,
    per: perView,
    search: search?.join(" "),
    status: status ?? status,
    category: category && eventTermData.find((el) => el.slug === category)?.id,
  });

  const genCategoryOptions = () => {
    const arr: Array<[string, string]> = [["", "全て"]];
    eventTermData.forEach((term: SonicTermData) =>
      arr.push([term.slug, term.name])
    );

    return arr;
  };

  return (
    <ListWrapper pageTitle="イベント一覧">
      <ListContentWrapper
        isLoading={isLoading}
        displayCount={genDisplayCount(currentPage, totalPage, perView, entries)}
        totalEntries={entries}
        status={status}
        handleStatus={handleStatus}
        category={category}
        handleCategory={handleCategory}
        categoryOptions={genCategoryOptions()}
        currentPage={currentPage}
        totalPage={totalPage}
        optionalComponent={
          handleSearch && search ? (
            <AdminSearchWidget handleSearch={handleSearch} search={search} />
          ) : undefined
        }
      >
        <EventList events={events} isSelect={isSelect} owners={owners} />
      </ListContentWrapper>
    </ListWrapper>
  );
};

export default EventListContainer;
